<template>
  <Header />

  <FriendAdd />

  <Footer />
</template>

<script>
import Footer from "@/components/Footer.vue";
import Header from "@/components/Header.vue";
import FriendAdd from "@/components/FriendAdd.vue";

export default {
  name: "GiftView",
  components: {
    Header,
    Footer,
    FriendAdd,
  },
  created() {
    if (this.$store.state.user.data.plan !== 'paid' && this.$store.state.friendMap.length >= 5) {
      this.$router.push('/friends')
    };
  },
};
</script>
